import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ChangeDetectorRef, Input, Injectable } from '@angular/core';
import { AuftragEx, AuftragspositionEx, ReCoMobilChargeEx } from 'src/app/api/model/model';
import { ModalController, IonSelect, IonSearchbar } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { NVE, NVEMenge, NVEMengenmeldungRequest } from 'src/app/api/model/swagger-model';

import { Utils } from 'src/app/api/helper/utils';
import { AuftragLieferungDetailsPage } from '../auftrag-lieferung-details/auftrag-lieferung-details.page';
import { IAuftragdetails } from '../auftragdetails/iauftragdetails';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BarcodeAuthGuard } from 'src/app/shared/barcode.guard';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { RemoteService } from 'src/app/api/remote.service';

const log = new Logger("AuftragNVEScannenPage");

@Component({
    selector: 'app-auftrag-nve-scannen',
    templateUrl: './auftrag-nve-scannen.page.html',
    styleUrls: ['./auftrag-nve-scannen.page.scss'],
    standalone: false
})
export class AuftragNVEScannenPage implements OnInit, AfterViewInit, OnDestroy {

    @Input() auftrag: AuftragEx;
    @Input() position: AuftragspositionEx;
    @Input() auftragdetails: IAuftragdetails;

    /**
     * Die gescannte NVE, mit der dieser Dialog geöffnet wurde
     */
    @Input() nve: NVE;

    subscriptions: Subscription[] = [];
    leaveWurdeAufgerufen = false;

    suchButtonAnzeigen = new BehaviorSubject<boolean>(false);
    searchbarSichtbar = new BehaviorSubject<boolean>(false);
    suchtext = '';

    positionsEigenschaftenImmerAnzeigen = false;

    title = new BehaviorSubject('NVE Scannen');

    positionHinzufuegenErlaubt = true;

    sollMenge = 0;
    istMenge = 0;
    restMenge = 0;

    chargen?: ReCoMobilChargeEx[];

    testButtonsAnzeigen = false;

    constructor(
        private auftragService: AuftragService,
        private remoteService: RemoteService,
        private modalController: ModalController,
        private cdr: ChangeDetectorRef) { }

    async ngOnInit() {
        // this.suchButtonAnzeigen.next(AppConfig.current.einstellungen.AuftragspositionenSuchButtonAnzeigen === 'ja');

        this.testButtonsAnzeigen = !MyApp.isCordovaAvailable();

        this.subscriptions.push(this.auftragService.aktuellerauftragWurdeGeaendert.subscribe(() => {
            this.dismiss();
        }));

        if (!this.position.Chargen) {
            this.position.Chargen = [];
        }

        // Es soll auf einer Kopie der Chargen-Liste gearbeitet werden.
        // 
        this.chargen = Utils.clone(this.position.Chargen); // JSON.parse(JSON.spr)

        if (this.nve) {
            // Prüfe ob die NVE überhaubt genug Rest-Menge hat
            if (this.nve.MengeAktuell == null) {
                this.nve.MengeAktuell = this.nve.MengeInitial;
            }

            let chargeIndex = this.position.Chargen.findIndex(p => p.NVE == this.nve.Key);

            if (this.position.Fertig) {
                UiHelper.showErrorLight('Position wurde bereits gebucht!');

                if (chargeIndex < 0) {
                    const charge: ReCoMobilChargeEx = {
                        Pos: this.chargen.length + 1,
                        NVE: this.nve.Key,
                        Charge: this.nve.Charge,
                        Menge: 0,
                        MHD: Utils.formatDatum(this.nve.MHD),
                        restMenge: this.nve.MengeAktuell,
                        restMengeZuGering: false // Wird durch die Update-Methode aktualisiert
                    };

                    this.chargen.push(charge);
                }
            } else {
                if (chargeIndex >= 0) {
                    // Diese NVE wurde schon einmal gescannt.
                    // Das tritt auf wenn der Dialog geschlossen und erneu gescannt wird.
                    // Dann soll die Position neu hinzugefügt werden.
                    const alteCharge = this.position.Chargen[chargeIndex];

                    if (alteCharge.Menge) {
                        // Menge muss zurück gebucht werden
                        this.nve.MengeAktuell += alteCharge.Menge;
                    }

                    this.chargen.splice(chargeIndex, 1);
                }

                // Berechne die notwendige Rest-Menge
                let mengeIst = this.chargen.map(p => p.Menge).reduce((pv, vc) => pv + vc, 0);
                let mengeSoll = this.position.MengeSoll;
                let mengeRest = mengeSoll - mengeIst;
                let chargeMenge = mengeRest;


                if (this.nve.MengeAktuell < mengeRest) {
                    chargeMenge = this.nve.MengeAktuell;
                }

                const charge: ReCoMobilChargeEx = {
                    Pos: this.chargen.length + 1,
                    NVE: this.nve.Key,
                    Charge: this.nve.Charge,
                    Menge: chargeMenge,
                    MHD: Utils.formatDatum(this.nve.MHD),
                    restMenge: this.nve.MengeAktuell,
                    restMengeZuGering: false // Wird durch die Update-Methode aktualisiert
                };

                this.chargen.push(charge);
            }
        }

        this.update();
    }

    ngAfterViewInit() {
    }

    ionViewDidEnter() {
        MyApp.current.backAction = () => this.onAbbrechen();

        this.auftragService.setzeAktivenAuftrag(this.auftrag, 'lieferung');
    }

    async ionViewWillLeave() {
        log?.debug('ionViewWillLeave');

        this.leaveWurdeAufgerufen = true;

        MyApp.current.backAction = null;

        if (this.auftragService.istAktiverAuftrag(this.auftrag)) {
            await Utils.delay(50);

            await this.auftragService.speichereAuftrag(this.auftrag);
        } else {
            log.warn('ionViewWillLeave: nicht aktiver Auftrag ' + this.auftrag.Key);
        }
    }

    /**
     * Runs when the page is about to be destroyed and have its elements removed.
     */
    ngOnDestroy() {
        log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        if (!this.leaveWurdeAufgerufen) {
            // Das tritt normalerweise nur im wizard-Modus auf.
            // hier fehlt das ionWillLead-Event
            this.ionViewWillLeave();
        }
    }

    async onAbbrechen() {
        log?.debug('onAbbrechen');

        const ok = await UiHelper.confirmJaNein('Wirklich abbrechen?');

        if (ok) {
            this.dismiss();
        }
    }

    async onSpeichern() {
        log?.debug('onSpeichern');
        this.doSpeichern();
    }

    async doSpeichern() {
        log?.info('doSpeichern: ' + this.auftrag.Key, this.auftrag);

        this.update();

        if (this.restMenge) {
            const ok = await UiHelper.confirmJaNein('ACHTUNG: Soll-Menge wurde nicht erreicht. Wirklich eine abweichende Menge buchen?');

            if (!ok) {
                return;
            }
        }

        const request: NVEMengenmeldungRequest = {
            AuftragKey: this.auftrag.Key,
            Auftragsposition: this.position,
            Mengen: []
        };

        // Berechne die Mengen-Differenz aus der bereits gebuchten menge und der neuen Menge
        for (const charge of this.chargen) {
            const alteCharge = this.position.Chargen.find(p => p.NVE === charge.NVE);

            let nveMenge: NVEMenge = {
                NVE: charge.NVE,

                // Menge muss negativ sein, da die Menge von der NVE entnommen wird
                Menge: -charge.Menge
            };

            if (alteCharge) {
                // Für diese NVE wurde bereits eine Menge gebucht.
                // Die zuvor gemeldete Menge muss jetzt wieder der NVE hinzugebucht werden (da die Entnehme storniert wird)
                nveMenge.Menge += alteCharge.Menge;
            }

            if (nveMenge.Menge != 0) {
                request.Mengen.push(nveMenge);
            }
        }

        if (request.Mengen.length) {
            const result = await this.remoteService.nveMengenmeldung(request);

            if (!result) {
                UiHelper.showFehlerKommunikation();
                return;
            }

            if (result.ErrorMessage) {
                UiHelper.showErrorOhneSentry(result.ErrorMessage);
                return;
            }
        }

        // Speichern.
        this.position.Chargen = this.chargen.filter(p => p.NVE && !!p.Menge);

        let pos = 1;

        for (const charge of this.position.Chargen) {
            charge.Pos = pos++;
        }

        this.modalController.dismiss({
            'dismissed': true,
            'gespeichert': true
        });
    }

    onReset() {
    }

    dismiss() {
        this.modalController.dismiss({
            'dismissed': true
        });
    }

    onMengeChanged(charge: ReCoMobilChargeEx, e: any) {
        log?.debug('onMengeChanged', { charge, e });
        this.update();
    }

    update() {
        this.sollMenge = this.position.MengeSoll;
        this.istMenge = 0;
        this.restMenge = this.sollMenge;

        for (const charge of this.chargen) {
            this.istMenge += charge.Menge;

            if (charge.restMenge && charge.restMenge < this.restMenge) {
                charge.restMengeZuGering = true;
            } else {
                charge.restMengeZuGering = false;
            }

            this.restMenge -= charge.Menge;
        }
    }

    async onSimuliereBarcode(format: string, text: string) {
        UiHelper.showAlert('Noch nicht implementiert', 'TODO');

        // await this.verarbeiteBarcodeVonProGlove({
        //     format: format,
        //     text: text,
        //     source: 'SIMULATION'
        // });
    }
}

// @Injectable()
// export class AuftragNVEScannenGuard implements CanDeactivate<Comment> {

//     static barcodeScanAktiv = false;

//     constructor() { }

//     canDeactivate(component: Comment, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
//         if (BarcodeAuthGuard.barcodeScanAktiv) {
//             return false;
//         }

//         return true;
//     }
// }
